import { useWindowSize } from "./useWindowSize";

export const WindowSizeInitializer = () => {
	useWindowSize();

	return null;
};
